<script lang="ts">
	import {
		PUBLIC_GOOGLE_ADS_CONVERSION_ID,
		PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID
	} from '$env/static/public';
	import { onMount } from 'svelte';

	onMount(() => {
		window.gtag('js', new Date());
		window.gtag('config', PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID);
		window.gtag('config', PUBLIC_GOOGLE_ADS_CONVERSION_ID, { allow_enhanced_conversions: true });
	});
</script>

<svelte:head>
	<script>
		window.dataLayer = window.dataLayer || [];

		function gtag() {
			window.dataLayer.push(arguments);
		}
	</script>
</svelte:head>
